import React, { FocusEvent, ChangeEvent } from 'react';
import { Form } from 'react-bootstrap';

/**
 * IsProcedureExecutorFormコンポーネント用のPropsです。
 * @interface IsProcedureExecutorFormProps
 */
interface IsProcedureExecutorFormProps {

  /**
   * 索引
   * @type {boolean}
   * @memberof IsProcedureExecutorFormProps
   */
  index: number;


  /**
   * 手続実行者フラグ
   * @type {boolean}
   * @memberof IsProcedureExecutorFormProps
   */
  isChecked: boolean;

  /**
   * 手続実行者フラグを設定する関数
   * @memberof IsProcedureExecutorFormProps
   */
  onChange: (isChecked: boolean) => void;
}

/**
 * 手続実行者フォームのコンポーネントです。
 * @param {string} props.isChecked - 表示する手続実行者フラグ
 * @param {function} props.onChange - 表示する手続実行者フラグが変更されたときに呼ばれるコールバック関数
 * @returns {JSX.Element} - 表示する手続実行者フォームのJSX要素
 */
const IsProcedureExecutorForm: React.FC<IsProcedureExecutorFormProps> = ({ index, isChecked, onChange }) => {

  /**
   * フォームの変更イベントハンドラーです。
   * 入力された手続実行者フラグをonChange関数を呼び出します。
   * @param {object} event - フォームの変更イベント
   * @returns {void}
   */
  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    onChange(event.target.checked);
  };

  return (
    <Form.Group controlId={`isProcedureExecutorForm${index.toString()}`}>
      <Form.Check
        type="checkbox"
        label="手続を行う代理人の場合はチェックをしてください。"
        checked={isChecked}
        onChange={handleChange}
      />
    </Form.Group>
  );
};

export default IsProcedureExecutorForm;